export default __webpack_public_path__ + "static/media/CardNft.00010931.png";